module.exports = __webpack_public_path__ + "static/media/prableen.f1e55a46.jpg";